import "core-js/modules/es.function.name.js";
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  class: "item-app"
};
var _hoisted_2 = {
  class: "img-div"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  key: 0,
  class: "tip not-use"
};
var _hoisted_5 = {
  key: 1,
  class: "tip"
};
var _hoisted_6 = {
  key: 2,
  class: "tip"
};
var _hoisted_7 = {
  key: 3,
  class: "tip"
};
var _hoisted_8 = {
  class: "item-name"
};
var _hoisted_9 = ["title"];
var _hoisted_10 = ["title"];
export default {
  __name: 'AppItem',
  props: {
    data: {
      type: Object,
      default: function _default() {}
    }
  },
  setup: function setup(__props) {
    var props = __props;
    return function (_ctx, _cache) {
      var _props$data$appDetai, _props$data$appDetai2;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        src: __props.data.appDetail.icon,
        fit: "cover",
        class: _normalizeClass(["item-icon", {
          'disabled-img': __props.data.showNotUse
        }])
      }, null, 10, _hoisted_3)]), __props.data.showNotUse ? (_openBlock(), _createElementBlock("div", _hoisted_4, "不可用")) : __props.data.num && __props.data.appDetail.alias !== 'chatQa' ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.data.num || 0), 1)) : __props.data.appDetail.alias === 'chatQa' && __props.data.unread > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.data.unread > 99 ? '99+' : __props.data.unread), 1)) : __props.data.isNew ? (_openBlock(), _createElementBlock("div", _hoisted_7, "new")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createElementVNode("p", {
        class: "name",
        title: __props.data.appDetail.name
      }, _toDisplayString(__props.data.appDetail.name), 9, _hoisted_9), _createElementVNode("div", {
        class: "item-desc",
        title: (_props$data$appDetai = __props.data.appDetail) === null || _props$data$appDetai === void 0 ? void 0 : _props$data$appDetai.tagline
      }, _toDisplayString(((_props$data$appDetai2 = __props.data.appDetail) === null || _props$data$appDetai2 === void 0 ? void 0 : _props$data$appDetai2.tagline) || ''), 9, _hoisted_10)])]);
    };
  }
};